import { Button } from 'antd';
import React, { FC, useMemo, useState } from 'react';
import { EmptyState } from '../empty_state/EmptyState';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	brandsRestCrudThunksForBuyer,
	brandsRestCrudThunksForSupplier,
} from '../../thunks/brands_thunks';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { BRANDS_CRUD_ACTION_CREATORS } from '../../actions/brands_actions';
import PaginatedReduxTableWithHeader from '../common/PaginatedReduxTableWithHeader';
import AddOrEditBrandPopup from './AddOrEditBrandPopup';
import BrandLogoDisplay from './BrandLogoDisplay';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

const TC_NAME = 'brandsIndex';

export const BrandDisplay: FC<any> = ({ brand }): React.ReactElement => {
	return (
		<div className="locationsIndexPage__row">
			<div>
				<div className="flex flex-row items-center">
					<BrandLogoDisplay brand={brand} />
					<div>
						<div className="locationsIndexPage__rowTitle">
							<Ellipsis tooltip={true} length={64}>
								{brand.brandName}
							</Ellipsis>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const BrandsOverviewIndexPage: FC<any> = ({
	brands,
	userType,
	updateFilters,
	clearAndUpdateFilters,
}): React.ReactElement => {
	const [brandPopUpVisible, setBrandPopUpVisible] = useState(false);
	const [editingBrand, setEditingBrand] = useState(null);

	const onBrandEdit = (brand) => () => {
		setEditingBrand(brand);
		_showBrandPopup();
	};

	const column = [
		{
			title: 'Name',
			dataIndex: 'brandName',
			defaultSortOrder: 'ascend',
			render: (text, record) => (
				<div className="flex flex-row items-center justify-between">
					<BrandDisplay brand={record} />
					<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_LOCATIONS}>
						<Button onClick={onBrandEdit(record)} type="ghost" size="large">
							Edit
						</Button>
					</AccessPermissionChecker>
				</div>
			),
		},
	];

	const _showBrandPopup = () => setBrandPopUpVisible(true);
	const _hideBrandPopup = () => setBrandPopUpVisible(false);

	const onBrandPopupCancel = () => {
		_hideBrandPopup();
		setEditingBrand(null);
	};

	const createNewButton = useMemo(
		() => (
			<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_LOCATIONS}>
				<Button style={{ marginLeft: 16 }} type="primary" size="large" onClick={_showBrandPopup}>
					New Brand
				</Button>
			</AccessPermissionChecker>
		),
		[]
	);

	return (
		<>
			<PaginatedReduxTableWithHeader
				targetCollectionName={TC_NAME}
				updateFilters={updateFilters}
				stateSlice={brands}
				clearAndUpdateFilters={clearAndUpdateFilters}
				filterConfig={[]}
				entityCollectionName="brands"
				tableColumns={column}
				fetchData={
					userType === ROLE_TYPES.SUPPLIER
						? brandsRestCrudThunksForSupplier.read
						: brandsRestCrudThunksForBuyer.read
				}
				rightActions={<div>{createNewButton}</div>}
				showHeader={false}
				hideSearch
				emptyState={
					<EmptyState
						graphic={
							<img
								alt="Looks like your team has not added any brands yet."
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
							/>
						}
						headline={"It's a little lonely in here."}
						body={
							<div style={{ textAlign: 'center' }}>
								<div style={{ maxWidth: 440, marginBottom: 16 }}>
									Looks like your team has not added any brands yet.
								</div>
								{createNewButton}
							</div>
						}
					/>
				}
			/>
			{brandPopUpVisible ? (
				<AddOrEditBrandPopup
					brand={editingBrand}
					onCancel={onBrandPopupCancel}
					targetCollectionName={TC_NAME}
				/>
			) : null}
		</>
	);
};

const mapStateToProps = (state) => ({
	brands: state.brands,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	updateFilters: (filters, targetCollection) =>
		dispatch(BRANDS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(BRANDS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(BrandsOverviewIndexPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
